import { render, staticRenderFns } from "./examKnow.vue?vue&type=template&id=f2666ac0&scoped=true"
import script from "./examKnow.vue?vue&type=script&lang=js"
export * from "./examKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2666ac0",
  null
  
)

export default component.exports